import React from 'react';
import Discord from "./assets/social-media-icons/discord.webp";
import Twitter from "./assets/social-media-icons/twitter.webp";

import "./styles/Navbar.scss";
import {
    
    NavLink
    
  } from "react-router-dom";
/* import roboPunksNFT from './questions.json';
import { useState } from "react";
import { useEffect } from "react";
import { ethers, BigNumber } from "ethers";
import About from './About'; */
import styled from 'styled-components';



export const Links = styled(NavLink)`
text-decoration: none;
color: #fff;
  &.active {
    text-decoration: none;
    color: #fff;
  }
`;


export default function Navbar({ accounts, setAccounts }) {

    const isConnected = Boolean(accounts[0]);
    

    async function connectAccount() {
        if (window.ethereum) {
            const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
            setAccounts(accounts);
        } else {
            window.alert("Please install metamask to use this website");
        }
    }


    return (

        <header className="header">
            <section className="iconContainer">


             <a href="https://twitter.com/canto_cuties" target="_blank" rel="noopener noreferrer">
                    <img src={Twitter} alt="twitter" />
                </a>   
            <a href="https://discord.gg/GM4aV3DRUR" target="_blank" rel="noopener noreferrer">
                    <img src={Discord} alt="discord" />
                </a>
                
                
            </section>

          
            <section className="navigation">
          

                <div><Links to='/' >
            Home
          </Links></div>
                
                <div><Links to='/about' activeStyle>
            About
          </Links></div>
          <div><Links to='/roadmap' activeStyle>
            Roadmap
          </Links></div>
          <div><Links to='/links' activeStyle>
            Links
          </Links></div>
          
                <div></div>

                
                {
                    isConnected ? ( <p>Connected</p> ) : ( <button onClick={connectAccount}>Connect</button> )
                }

                

            </section>
        </header>
    );
            }